import React, { useEffect, useState } from "react";
import "swiper/css";
import "swiper/css/navigation";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

const sliderContentStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  textAlign: "center",
};
const contentInnerStyle = {
  /* Optional: Add styles to adjust the padding, background, etc. */
};

const SwiperSliderH = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const animationTimer = setTimeout(() => {
      setAnimate(true);
    }, 500);

    return () => clearTimeout(animationTimer);
  }, [currentSlide]);

  const handleSlideChange = (swiper) => {
    setCurrentSlide(swiper.realIndex);
    setAnimate(false); // Reset animation for each new set of 3 slides
  };

  const [animate, setAnimate] = useState(false);

  return (
    <div>
      <Swiper
        onSlideChange={handleSlideChange}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        modules={[Autoplay, Pagination, Navigation]}
        className="mySwiper"
      >
        <SwiperSlide>
          <div className="slider-hero">
            <div
              className="item slider-item"
              style={{
                height: "650px",
                maxWidth: "100%",
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), url("/assets/images/slider1.png")`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "top center",
              }}
            />
            <div className="slider-content" style={sliderContentStyle}>
              <div className="content-inner" style={contentInnerStyle}>
                <h2
                  className={animate ? "enter-from-left" : "initial-opacity"}
                  style={{
                    fontWeight: "700",
                    color: "#fff",
                    opacity: animate ? 1 : 0,
                    transition: "opacity 0.8s ease-in-out",
                  }}
                >
                  Feroz Law Academy
                </h2>
                <h5
                  className={animate ? "enter-from-right" : "initial-opacity"}
                  style={{
                    marginTop: "7px",
                    fontWeight: "600",
                    fontSize: "22px",
                    color: "#dedffa",
                    opacity: animate ? 1 : 0,
                    transition: "opacity 0.8s ease-out",
                  }}
                >
                  A Pathway To Become An Advocate
                </h5>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="slider-hero">
            <div
              className="item slider-item"
              style={{
                height: "650px",
                maxWidth: "100%",
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url("/assets/images/slider4.jpg")`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "top center",
              }}
            />
            <div className="slider-content" style={sliderContentStyle}>
              <div className="content-inner" style={contentInnerStyle}>
              <h2
                  className={animate ? "enter-from-left" : "initial-opacity"}
                  style={{
                    fontWeight: "700",
                    color: "#fff",
                    opacity: animate ? 1 : 0,
                    transition: "opacity 0.8s ease-in-out",
                  }}
                >
                  Feroz Law Academy
                </h2>
                <h5
                  className={animate ? "enter-from-right" : "initial-opacity"}
                  style={{
                    marginTop: "7px",
                    fontWeight: "600",
                    fontSize: "22px",
                    color: "#dedffa",
                    opacity: animate ? 1 : 0,
                    transition: "opacity 0.8s ease-out",
                  }}
                >
                  A Pathway To Become An Advocate
                </h5>
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <div className="slider-hero">
            <div
              className="item slider-item"
              style={{
                height: "650px",
                maxWidth: "100%",
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url("/assets/images/slider3.jpg")`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "top center",
              }}
            />
            <div className="slider-content" style={sliderContentStyle}>
              <div className="content-inner" style={contentInnerStyle}>
              <h2
                  className={animate ? "enter-from-left" : "initial-opacity"}
                  style={{
                    fontWeight: "700",
                    color: "#fff",
                    opacity: animate ? 1 : 0,
                    transition: "opacity 0.8s ease-in-out",
                  }}
                >
                  Feroz Law Academy
                </h2>
                <h5
                  className={animate ? "enter-from-right" : "initial-opacity"}
                  style={{
                    marginTop: "7px",
                    fontWeight: "600",
                    fontSize: "22px",
                    color: "#dedffa",
                    opacity: animate ? 1 : 0,
                    transition: "opacity 0.8s ease-out",
                  }}
                >
                  A Pathway To Become An Advocate
                </h5>
              </div>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default SwiperSliderH;
